import { render, staticRenderFns } from "./dashboard-mailboxes.vue?vue&type=template&id=72eb67c9&"
import script from "./dashboard-mailboxes.vue?vue&type=script&lang=ts&"
export * from "./dashboard-mailboxes.vue?vue&type=script&lang=ts&"
import style0 from "./dashboard-mailboxes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports